// Student Status Types
export const LOAD_STUDENT_MEAL_PLANS = 'LOAD_STUDENT_MEAL_PLANS';
export const LOAD_STUDENT_MEAL_PLANS_SUCCESS = 'LOAD_STUDENT_MEAL_PLANS_SUCCESS';
export const LOAD_STUDENT_MEAL_PLANS_ERROR = 'LOAD_STUDENT_MEAL_PLANS_ERROR';

export const LOAD_STUDENT_HOUSING_PERIODS = 'LOAD_STUDENT_HOUSING_PERIODS';
export const LOAD_STUDENT_HOUSING_PERIODS_SUCCESS = 'LOAD_STUDENT_HOUSING_PERIODS_SUCCESS';
export const LOAD_STUDENT_HOUSING_PERIODS_ERROR = 'LOAD_STUDENT_HOUSING_PERIODS_ERROR';

export const STUDENT_LIFE_SEARCH_STUDENTS = 'STUDENT_LIFE_SEARCH_STUDENTS';
export const STUDENT_LIFE_SEARCH_STUDENTS_SUCCESS = 'STUDENT_LIFE_SEARCH_STUDENTS_SUCCESS';
export const STUDENT_LIFE_SEARCH_STUDENTS_ERROR = 'STUDENT_LIFE_SEARCH_STUDENTS_ERROR';
export const STUDENT_LIFE_RESET_STUDENT_SEARCH_RESULTS = 'STUDENT_LIFE_RESET_STUDENT_SEARCH_RESULTS';
export const STUDENT_LIFE_RESET_ASSIGNED_ROOMS = "STUDENT_LIFE_RESET_ASSIGNED_ROOMS";
export const STUDENT_LIFE_RESET_ASSIGNED_MEALPLANS = "STUDENT_LIFE_RESET_ASSIGNED_MEALPLANS";
